module.exports = __webpack_public_path__ + "img/Metacritic_logo.fb96c428.png";